import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data.map((item: any) => ({
    id: item?.id,
    packageName: item?.packageName,
    instrument: item?.instrument,
    fileName: item?.fileName,
    isGenerated: item?.isGenerated,
  }))
}

const getAllPackageToInstruments = (tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.routingPack2InstGetAll),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getAllPackageToInstruments }
